<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Lista de Serviços</h1>
            <p class="welcome-message">Gerenciamento de serviços</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
          @if (selection.hasValue()) {
          <span>Ações ({{ selection.selected.length }})</span>
          } @else {
          <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #opcoesMenu="matMenu">
          <button mat-menu-item (click)="abrirModalExcluir()" [disabled]="!selection.hasValue()">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            <span>Excluir selecionados</span>
          </button>
        </mat-menu>

        <button type="button" mat-flat-button class="btn-primary" routerLink="/cadastros/servicos/cadastrar">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Novo Serviço
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa" placeholder="Pesquise por descrição ou código" />

            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 filter-container">
          <button mat-stroked-button type="button" class="btn-filter desktop-view" (click)="configurarColunas()">
            <mat-icon>view_column</mat-icon>
            Configurar Colunas
          </button>
        </div>
      </div>
    </form>

    @if (_listaServicosResponse && _dataSource.data.length > 0) {
    <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="w-checkbox">
          <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
            [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="w-checkbox">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
        <td mat-cell *matCellDef="let row" [matTooltip]="row.descricao">{{ row.descricao | truncate:80 }}</td>
      </ng-container>

      <ng-container matColumnDef="codigo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
        <td mat-cell *matCellDef="let row">{{ row.codigo }}</td>
      </ng-container>

      <ng-container matColumnDef="preco">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Valor</th>
        <td mat-cell *matCellDef="let row">
          {{ formatarPreco(row.preco) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="isAtivo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let row">
          @if (row.isAtivo) {
          <div class="status-badge badge-verde">Ativo</div>
          } @else {
          <div class="status-badge badge-cinza">Inativo</div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
        <td mat-cell *matCellDef="let row" class="text-center w-actions">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações" (click)="$event.stopPropagation()">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item [routerLink]="['/cadastros/servicos/cadastrar', row.idServico]">
              <span class="material-symbols-outlined">edit</span>
              <span>Editar</span>
            </button>
            <button mat-menu-item (click)="abrirModalExcluir(row)">
              <span class="material-symbols-outlined">delete</span>
              <span>Excluir</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="mobile-view">
      @for (servico of _dataSource.data; track servico.idServico) {
      <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(servico)">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <mat-checkbox (change)="$event ? selection.toggle(servico) : null" [checked]="selection.isSelected(servico)"
              color="primary">
            </mat-checkbox>
            <div class="d-flex flex-column">
              <span class="text-bold" [matTooltip]="servico.descricao">{{ servico.descricao | truncate:50 }}</span>
              @if (servico.codigo) {
              <small>Código: {{ servico.codigo }}</small>
              }
            </div>
          </div>
          <button mat-icon-button [matMenuTriggerFor]="menuMobile">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuMobile="matMenu">
            <button mat-menu-item [routerLink]="['/cadastros/servicos/cadastrar', servico.idServico]">
              Editar
            </button>
            <button mat-menu-item (click)="abrirModalExcluir(servico)">Excluir</button>
          </mat-menu>
        </div>
        <div class="card-body-mobile p-3">
          <div class="row">
            <div class="col-6 mb-2">
              <small class="d-block">Valor</small>
              <span class="text-bold">{{ formatarPreco(servico.preco) }}</span>
            </div>
            <div class="col-6 mb-2">
              <small class="d-block">Status</small>
              @if (servico.isAtivo) {
              <div class="status-badge badge-verde">Ativo</div>
              } @else {
              <div class="status-badge badge-cinza">Inativo</div>
              }
            </div>
          </div>
        </div>
      </div>
      }
    </div>

    <div class="col-12 text-center">
      <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
        @if (_isLoading === true) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
      </button>
    </div>
    } @else if (_isLoading === true && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
    <app-empty-list [title]="'Nenhum serviço encontrado'"
      [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }
  </div>
</div>
